import { render } from "./TagScoreDetail.vue?vue&type=template&id=37187bc8"
import script from "./TagScoreDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TagScoreDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/jbh/achievementManage/tagScore/TagScoreDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37187bc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37187bc8', __exports__)) {
    console.log('reload')
    api.reload('37187bc8', __exports__)
  }
  
  module.hot.accept("./TagScoreDetail.vue?vue&type=template&id=37187bc8", () => {
    console.log('re-render')
    api.rerender('37187bc8', render)
  })

}


export default __exports__